import type React from "react"
import { Box, Skeleton } from "@mui/material"

export const NotificationSettingsSkeleton: React.FC = () => {
    return (
        <Box sx={{ maxHeight: "65vh", overflow: "auto" }}>
            {[1, 2, 3, 4, 5].map((item) => (
                <Box key={item} sx={{ mb: 3, p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                        }}
                    >
                        <Box sx={{ flex: 1 }}>
                            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                <Skeleton variant="circular" width={20} height={20} sx={{ mr: 1 }} />
                                <Skeleton variant="text" width={120} height={24} />
                            </Box>
                            <Skeleton variant="text" width="80%" height={16} />
                            <Skeleton variant="text" width="60%" height={16} />
                        </Box>
                        <Skeleton variant="rectangular" width={58} height={38} sx={{ ml: 2, borderRadius: 3 }} />
                    </Box>
                </Box>
            ))}
        </Box>
    )
}
